global.SHIPMENTS_API_URL = process.env.SHIPMENTS_API_URL
// TODO: Client Web API endpoints are being migrated to importscan-rewrite-api
// (IMPORTSCAN_AWS_URL); account-info moved in PLATFORM-188. Move the remaining
// USERS_API_URL calls as their rewrite-api equivalents land.
global.USERS_API_URL = process.env.USERS_API_URL
global.SUBSCRIPTIONS_API_URL = process.env.SUBSCRIPTIONS_API_URL
global.PAYMENTS_API_URL = process.env.PAYMENTS_API_URL
global.COMPANY_API_URL = process.env.COMPANY_API_URL
global.IMPORTSCAN_AWS_URL = process.env.IMPORTSCAN_AWS_URL
global.COMPANY_PROFILE_LAMBDA_URL = process.env.COMPANY_PROFILE_LAMBDA_URL
global.REDIRECT_URLS = {
  UPGRADE_SUBSCRIPTION_PLACEHOLDER:
    'https://app.importgenius.com/help/default_page/',
  LEGACY_APP_LOGIN: `${process.env.LEGACY_APP_URL}/`,
  CONSOLE_APP_URL: process.env.CONSOLE_APP_URL,
  SITE_URL: process.env.SITE_URL
}

global.PROMO_URL = `${process.env.LEGACY_APP_URL}/promo`

global.ISNG_TITLE = 'ImportGenius Lighthouse (Beta)'
